export const enum PropertyListViewStoreEvent {
  deleteProperty = 'deleteProperty',
  unsaveProperty = 'unsaveProperty',
  clickEmail = 'clickEmail',
}
